import { useNavigate } from "react-router-dom";
import { useClientRecordPractice } from "@/lib/clientRecordQueries";

const STATE_LABELS = { not_started: "Not started", available: "Available", in_progress: "In progress", done: "Done" };

export default function PracticeLayersTab({ workspaceId, memberId }) {
  const navigate = useNavigate();
  const { data, isPending, isError } = useClientRecordPractice(workspaceId, memberId);

  if (isPending) return <p className="text-sm text-ink-soft" data-testid="client-360-practice-loading">Loading practice progress…</p>;
  if (isError) return <p className="text-sm text-red-600" data-testid="client-360-practice-error">Couldn't load practice progress.</p>;
  if (data.items.length === 0) return <p className="text-sm text-ink-soft" data-testid="client-360-practice-empty">No Journey published yet — see Journey Configuration.</p>;

  return (
    <div className="space-y-2" data-testid="client-360-practice-layers-tab">
      {data.items.map((s) => (
        <div key={s.stage_key} className="border border-ink/10 rounded-lg p-3 bg-white/50 flex items-center justify-between gap-3" data-testid={`client-360-practice-stage-${s.stage_key}`}>
          <div>
            <p className="text-sm text-ink font-medium">{s.label}</p>
            <p className="text-xs text-ink-soft uppercase">{s.track} track</p>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            <span className="text-xs text-ink-soft uppercase">{STATE_LABELS[s.state] || s.state}</span>
            <button
              onClick={() => navigate(`/rehearsal-room/w/${workspaceId}/practice/${s.layer_key}`)}
              className="text-xs text-terracotta hover:underline"
              data-testid={`client-360-practice-open-${s.stage_key}`}
            >
              Open →
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
